// EdmingleHeroAdvanced.jsx
import React from "react";

export default function HeroCard5() {
  return (
    <>
      <section className="ed-hero-adv">
        <div className="ed-wrap">

          {/* LEFT */}
          <div className="ed-left fadeInUp">
            <h1 className="ed-title">
              <span className="ed-line" aria-hidden />
              your training business <br />
              with <span className="ed-highlight">ZERO operational hassles</span>
            </h1>

            <p className="ed-sub">
              Deliver training programs, convert insights into profit, and build lasting learner loyalty—all under your brand.
            </p>

            <div className="ed-cta-row">
              <button className="ed-btn btn-anim">Book a Demo</button>
              <div className="ed-rating">
                <span>RATED ★★★★★ (4.8+)</span>
                <div className="edu-avatars">
                <img src="https://i.pravatar.cc/100?img=1" />
                <img src="https://i.pravatar.cc/100?img=2" />
                <img src="https://i.pravatar.cc/100?img=3" />
                <span>24k+ Happy Students</span>
              </div>
              </div>
            </div>
          </div>

          {/* RIGHT: advanced visual area */}
          <div className="ed-right">
            <div className="visual-stage">

              {/* Particle lights (many small spans animated) */}
              <div className="particles" aria-hidden>
                {Array.from({ length: 22 }).map((_, i) => (
                  <span className={`p p${i % 7}`} key={i} />
                ))}
              </div>

              {/* Multi-layer halo rings */}
              <div className="halo halo-outer" />
              <div className="halo halo-mid" />
              <div className="halo halo-inner" />

              {/* Responsive SVG shapes behind image */}
              <svg className="bg-shapes" viewBox="0 0 400 400" preserveAspectRatio="xMidYMid slice" aria-hidden>
                <defs>
                  <linearGradient id="g1" x1="0" x2="1">
                    <stop offset="0" stopColor="#5c27fe" stopOpacity="0.25" />
                    <stop offset="1" stopColor="#0ac27a" stopOpacity="0.12" />
                  </linearGradient>
                </defs>
                <circle cx="300" cy="100" r="120" fill="url(#g1)" />
                <rect x="20" y="220" width="140" height="120" rx="28" fill="#ffffff08" />
              </svg>

              {/* Dotted animated curve (SVG) */}
              <svg className="dotted-curve" viewBox="0 0 800 200" preserveAspectRatio="none" aria-hidden>
                <path className="curve" d="M0,120 C160,40 320,180 480,110 C640,40 800,140 1000,80" fill="none" stroke="#ffffff66" strokeWidth="3" strokeDasharray="6 10" strokeLinecap="round" />
              </svg>

              {/* Main person image */}
              <div className="portrait-wrap scaleIn">
                <img
                  src="https://cdn-icons-png.flaticon.com/512/5968/5968853.png"
                  alt="trainer"
                  className="portrait"
                />

                {/* Lottie-style animated UI cards (CSS keyframe micro-animations) */}
                <div className="ui-card card-a lottieLike">
                  <div className="card-title">Sales</div>
                  <div className="card-amount">$4.8k</div>
                </div>

                <div className="ui-card card-b lottieLike">
                  <div className="card-title">Students</div>
                  <div className="card-amount">5.5M</div>
                </div>

                <div className="ui-card card-c lottieLike">
                  <div className="card-title">Sessions</div>
                  <div className="card-amount">12k</div>
                </div>

              </div>
            </div>
          </div>

        </div>
      </section>

      {/* Inline styles for convenience */}
      <style>{`
:root{
  --bg1:#05061f;
  --bg2:#0c113f;
  --accent:#ffca28;
  --primary:#1a73ff;
  --soft:#ffffff10;
}

/* ---------- Section base ---------- */
.ed-hero-adv {
  background: radial-gradient(circle at 18% 18%, var(--bg2), var(--bg1) 60%);
  color: #fff;
  padding: 84px 0 140px;
  font-family: Inter, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial;
  overflow: hidden;
}

.ed-wrap {
  width: 92%;
  max-width: 1320px;
  margin: 0 auto;
  display:flex;
  gap: 36px;
  align-items: center;
  justify-content: space-between;
}

/* ---------- Left ---------- */
.ed-left { flex:1.1; min-width:320px; }

.ed-title {
  font-size: 44px;
  line-height:1.08;
  font-weight:800;
  margin:0 0 18px 0;
  display:flex;
  align-items:flex-start;
  color: #fff;
}

.ed-line {
  width:12px;
  height:62px;
  background: linear-gradient(180deg,#712cff,#9a59ff);
  border-radius:8px;
  margin-right:14px;
  display:inline-block;
  flex-shrink:0;
}

.ed-highlight { color: var(--accent); }

.ed-sub {
  color: #c9c9e0;
  font-size:16.5px;
  width:82%;
  margin-bottom:20px;
}

/* CTA row */
.ed-cta-row { display:flex; align-items:center; gap:22px; flex-wrap:wrap; }

.ed-btn {
  background: linear-gradient(180deg,#2485ff,#1a5eff);
  padding:12px 28px;
  border-radius:10px;
  border:none;
  color:#fff;font-weight:700;
  cursor:pointer;
  box-shadow:0 10px 30px rgba(0,0,0,0.45);
  transition: transform .22s ease, box-shadow .22s ease;
}
.ed-btn:hover { transform: translateY(-6px); box-shadow:0 20px 40px rgba(0,0,0,0.6); }

.ed-rating { display:flex; flex-direction:column; gap:8px; margin-top:16px; color:#dfdfef; font-weight:600; }
.ed-logos { display:flex; gap:12px; align-items:center; margin-top:6px; }
.ed-logos img { width:86px; opacity:.95 }

/* ---------- Right / Visual Stage ---------- */
.ed-right { flex:1; display:flex; justify-content:center; align-items:center; min-width:360px; }

.visual-stage { position:relative; width:420px; height:420px; display:block; }

/* ---------- Particles (CSS) ---------- */
.particles { position:absolute; inset:0; pointer-events:none; z-index:2; }
.particles .p {
  position:absolute;
  width:8px; height:8px;
  background: radial-gradient(circle at 30% 30%,#fff,#cfe8ff 70%);
  border-radius:50%;
  opacity:0.85;
  filter: blur(0.6px);
  transform-origin:center;
  mix-blend-mode: screen;
}

/* pseudo-random positions + durations - 7 variants */
.p0{ left:6%; top:12%; animation: part0 8s linear infinite; transform:translateZ(0) scale(.9); }
.p1{ right:8%; top:18%; animation: part1 10s linear infinite; background: radial-gradient(circle,#ffd88a,#fff0 70%); }
.p2{ left:22%; bottom:8%; animation: part2 12s linear infinite; background: radial-gradient(circle,#7af6b1,#fff0 70%); }
.p3{ right:28%; bottom:22%; animation: part3 9s linear infinite; width:10px;height:10px; }
.p4{ left:62%; top:10%; animation: part4 11s linear infinite; background: radial-gradient(circle,#9ac6ff,#fff0 70%); }
.p5{ left:40%; top:62%; animation: part5 9.5s linear infinite; width:6px;height:6px; opacity:.7; }
.p6{ right:48%; top:40%; animation: part6 13s linear infinite; }

/* particle keyframes (gentle drift + pulse) */
@keyframes part0 { 0%{ transform:translateY(0) scale(.9) }50%{ transform:translateY(-18px) scale(1.12)}100%{transform:translateY(0) scale(.9)} }
@keyframes part1 { 0%{ transform:translateY(0) }50%{ transform:translateY(-30px) scale(1.05)}100%{transform:translateY(0)} }
@keyframes part2 { 0%{ transform:translateY(0) }50%{ transform:translateY(-12px) scale(.95)}100%{transform:translateY(0)} }
@keyframes part3 { 0%{ transform:translateY(0)}50%{ transform:translateY(-26px) rotate(8deg)}100%{transform:translateY(0)} }
@keyframes part4 { 0%{ transform:translateY(0)}50%{ transform:translateY(-22px) }100%{transform:translateY(0)} }
@keyframes part5 { 0%{ transform:translateY(0)}50%{ transform:translateY(-10px) }100%{transform:translateY(0)} }
@keyframes part6 { 0%{ transform:translateY(0)}50%{ transform:translateY(-28px) }100%{transform:translateY(0)} }

/* ---------- Multi-layer rotating halo rings ---------- */
.halo {
  position:absolute;
  left:50%; top:50%;
  transform:translate(-50%,-50%);
  border-radius:50%;
  pointer-events:none;
  z-index:1;
  mix-blend-mode:screen;
  opacity:.9;
}

.halo-outer { width:420px; height:420px; background: conic-gradient(from 90deg, rgba(22,110,255,0.07), rgba(22,255,200,0.02)); filter: blur(22px); animation: spinA 30s linear infinite; }
.halo-mid   { width:320px; height:320px; background: conic-gradient(from 270deg, rgba(180,60,240,0.06), rgba(240,200,50,0.02)); filter: blur(20px); animation: spinB 22s linear infinite reverse; }
.halo-inner { width:220px; height:220px; background: conic-gradient(from 10deg, rgba(120,200,255,0.08), rgba(255,120,160,0.02)); filter: blur(16px); animation: spinC 16s linear infinite; }

@keyframes spinA { to { transform: translate(-50%, -50%) rotate(360deg); } }
@keyframes spinB { to { transform: translate(-50%, -50%) rotate(-360deg); } }
@keyframes spinC { to { transform: translate(-50%, -50%) rotate(360deg); } }

/* ---------- Responsive SVG shapes behind image ---------- */
.bg-shapes {
  position:absolute; right:-90px; top:-80px; width:420px; height:420px; z-index:0; opacity:.85;
  transform: scale(1.0);
  transition: transform .4s ease;
}

/* dotted animated curve */
.dotted-curve { position:absolute; left:-60px; top:18px; width:520px; height:120px; z-index:3; opacity:.55; pointer-events:none; }
.dotted-curve .curve { stroke-dashoffset:0; animation: dashMove 6.5s linear infinite; }

@keyframes dashMove { 0%{ stroke-dashoffset:0 } 100%{ stroke-dashoffset:-80 } }

/* ---------- Portrait and Lottie-like UI cards ---------- */
.portrait-wrap { position:absolute; left:12px; top:14px; width:280px; height:380px; z-index:4; display:flex; align-items:center; justify-content:center; pointer-events:none; }
.portrait { width:240px; border-radius:12px; box-shadow: 0 28px 60px rgba(2,10,30,0.6); transform: translateZ(0); }

/* UI cards that animate like Lottie micro-motions */
.ui-card {
  position:absolute; width:126px; padding:8px; border-radius:12px; background:linear-gradient(180deg,#ffffffee,#f7f9ffcc); color:#001;
  box-shadow: 0 18px 36px rgba(2,10,30,0.48);
  transform-origin:center; z-index:6; pointer-events:auto;
  display:flex; flex-direction:column; gap:6px; align-items:flex-start; justify-content:center;
  font-weight:700;
}
.ui-card .card-title { font-size:12px; color:#333; font-weight:700; opacity:.95; }
.ui-card .card-amount { font-size:18px; color:#0a6aff; }

/* positions */
.card-a { top:40px; right:-46px; transform: translateZ(0); animation: cardA 5s ease-in-out infinite; }
.card-b { bottom:62px; right:-18px; animation: cardB 5.6s ease-in-out infinite; }
.card-c { top:190px; left:-46px; animation: cardC 6.2s ease-in-out infinite; }

/* Lottie-like keyframes: subtle reposition + scale + fade */
@keyframes cardA {
  0% { transform: translate(0,0) scale(0.98) rotate(-1deg) }
  25%{ transform: translate(-6px,-8px) scale(1.02) rotate(0.5deg) }
  50%{ transform: translate(0,-12px) scale(1.04) rotate(1deg) }
  75%{ transform: translate(6px,-8px) scale(1.02) rotate(0.5deg) }
  100%{ transform: translate(0,0) scale(0.98) rotate(-1deg) }
}
@keyframes cardB {
  0% { transform: translate(0,0) scale(0.98) rotate(0.5deg) }
  50%{ transform: translate(0,-10px) scale(1.03) rotate(-0.6deg) }
  100%{ transform: translate(0,0) scale(0.98) rotate(0.5deg) }
}
@keyframes cardC {
  0% { transform: translate(0,0) scale(0.985) rotate(-0.6deg) }
  40%{ transform: translate(-8px,-6px) scale(1.02) rotate(0.6deg) }
  80%{ transform: translate(6px,-10px) scale(1.04) rotate(1.2deg) }
  100%{ transform: translate(0,0) scale(0.985) rotate(-0.6deg) }
}

/* ---------- Entry animations & utility ---------- */
.fadeInUp { opacity:0; animation: fadeUp .9s cubic-bezier(.2,.9,.2,1) forwards; }
@keyframes fadeUp { 0%{ opacity:0; transform: translateY(22px) }100%{ opacity:1; transform: translateY(0) } }

.scaleIn { opacity:0; transform:scale(.95); animation: scaleIn .85s ease forwards .06s; }
@keyframes scaleIn { 0%{ opacity:0; transform:scale(.95) }100%{ opacity:1; transform:scale(1) } }

/* float */
.floatUp { animation: floatUp 5s ease-in-out infinite; }
@keyframes floatUp { 0%{ transform: translateY(0) }50%{ transform: translateY(-12px) }100%{ transform: translateY(0) } }

/* Responsive tweaks */
@media (max-width: 980px) {
  .ed-wrap { gap:20px; }
  .visual-stage { width:340px; height:340px; }
  .portrait-wrap { left:6px; top:8px; width:240px; height:320px; }
  .bg-shapes { right:-60px; top:-60px; width:360px; height:360px; }
  .ed-title { font-size:34px; }
  .ed-sub { width:100%; }
  .ed-left { order:2; }
  .ed-right { order:1; margin-bottom:18px; }
}

@media (max-width: 560px) {
  .ed-wrap { flex-direction:column-reverse; align-items:center; text-align:center; }
  .visual-stage { width:300px; height:300px; }
  .ed-title { font-size:28px; }
  .ed-logos img { width:60px; }
  .particles { display:none; } /* disable for low perf */
}
      `}</style>
    </>
  );
}
